import { useRouter } from "next/router";
import { LongArrowIcon } from "../icons/long-arrow-icon";
import { useTranslation } from "react-i18next";
import routes from "@/config/routes";

const BackButton = ({ fallbackUrl = '/' }) => {
  const { t } = useTranslation('common');
  const router = useRouter();

  const goBack = () => {
    const previousUrl = document.referrer;
    if (window.history.length > 1 && previousUrl.includes(window.location.host)) {
      // check if previous page is from same host
      router.back();
    } else {
      router.push(fallbackUrl);
    }
  };

  return (
    <div className="sticky top-0 z-200 -mx-4 mb-1 -mt-2 flex items-center p-4 bg-transparent sm:static sm:top-auto sm:z-0 sm:m-0 sm:mb-4 sm:bg-transparent sm:dark:bg-transparent">
      <button
        onClick={() => goBack()}
        className="group inline-flex w-20 items-center gap-1.5 font-medium text-dark/70 hover:text-dark rtl:flex-row-reverse dark:text-light/70 hover:dark:text-light"
      >
        <LongArrowIcon className="h-4 w-4" />
        {t('text-back')}
      </button>
    </div>
  )
}

export default BackButton